import React from 'react'
import WindowPattern from './patterns/PatternSelector'

const TwoLiteSlidingDoorDiagram = ({
  selectedValue,
  availableOptions,
  onChange,
  mode,
  disabled,
  formData,
  allAvailableOptions
}) => {
  const fullDoorOption = availableOptions?.find(opt =>
    !opt.name.toLowerCase().includes('sash') &&
    !opt.name.toLowerCase().includes('lite')
  ) || availableOptions?.[0]

  const isSelected = selectedValue === fullDoorOption?.id

  const handleClick = () => {
    if (disabled || mode === 'display') return
    onChange(isSelected ? null : fullDoorOption?.id)
  }

  // Get grid style name for pattern
  const selectedGridStyle = allAvailableOptions?.grid_styles?.find(
    style => style.id === formData?.grid_style_id
  )

  return (
    <div className="flex justify-center items-center">
      <div
        className={`
          relative w-36 h-72 bg-light border-8 border-r-0 border-brand
          ${disabled ? 'opacity-50' : ''}
        `}
        onClick={handleClick}
      >
        <WindowPattern
          mode={mode}
          isSelected={isSelected}
          gridStyleName={selectedGridStyle?.name}
        />
      </div>
      <div
        className={`
          relative w-36 h-72 bg-light border-8 border-brand
          ${disabled ? 'opacity-50' : ''}
        `}
        onClick={handleClick}
      >
        <WindowPattern
          mode={mode}
          isSelected={isSelected}
          gridStyleName={selectedGridStyle?.name}
        />
      </div>
    </div>
  )
}

export default TwoLiteSlidingDoorDiagram
